import { eTipoPermissao } from '@/enums/ePermissoes';
 
export default [
  {
    description: 'Relatório Notas Parciais e Totais',
    path: '/academico/relatorios/notasparciaistotais/turma',
    name: 'relatorio-notas-parciais-totais',
    component: () => import('@/views/academico/relatorios/notasparciaistotais/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.RELATORIO_NOTAS_PARCIAIS_TOTAIS_MENU_300802908],
    },
    goesToMenu: true,
  },
  {
    description: 'Configuração Relatório Notas Parciais e Totais',
    path: '/academico/relatorios/notasparciaistotais/turma/configuracao',
    parent: 'relatorio-notas-parciais-totais',
    name: 'relatorio-notas-parciais-totais-configuracao',
    component: () => import('@/views/academico/relatorios/notasparciaistotais/Configuracao.vue'),
    meta: {
      /*
       * A permissão é a da TELA MÃE, de propósito. Esta é uma sub-rota (`parent`, sem
       * `goesToMenu`): não é item de menu e não tem SegMenuId próprio — quem abre o relatório
       * abre a configuração dele. O 300802909 que ficava aqui não existia na Seg_Menu, e passou
       * a ser de um item de verdade (Notas e Faltas do Bimestre, tela nova).
       */
      permissions: [eTipoPermissao.RELATORIO_NOTAS_PARCIAIS_TOTAIS_MENU_300802908],
    },
  },
];